import Marionette from "backbone.marionette";
import Item from "./list-item";

const EmptyView = Marionette.ItemView.extend({
  tagName: "h4",
  className: "text-muted",
  template: _.template(
    "Your profile has not been configured with any environments. Please notify your administrator."
  ),
});

const DEFAULTS = {
  tagName: "ul",
  className: "list-group",
  childView: Item,
  emptyView: EmptyView,
};

class EnvironmentList extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  childEvents() {
    return {
      itemClicked: "onItemClicked",
    };
  }

  initialize() {
    // render component whenever an item is marked checked
    this.listenTo(this.collection, "change:checked", this.render);
  }

  onRender() {
    const itemChecked = !!this.collection.findWhere({ checked: true });
    this.triggerMethod("toggleSubmit", itemChecked);
  }

  onItemClicked(view, model) {
    // flip checked flag
    const checked = !model.getChecked();

    // uncheck all models
    this.collection.map((option) => option.setChecked(false));

    // update active model
    model.setChecked(checked);

    // merge updated model into collection
    this.collection.add(model, { merge: true });
  }
}

export { EnvironmentList as default };
